import { type ReactNode, createContext, useContext, useMemo, useState } from 'react';

interface RecordingState {
  isActive: boolean;
  setRecording: (active: boolean) => void;
  setUploading: (active: boolean) => void;
}

const RecordingContext = createContext<RecordingState | undefined>(undefined);

export const RecordingProvider = ({ children }: { children: ReactNode }) => {
  const [recording, setRecording] = useState(false);
  const [uploading, setUploading] = useState(false);
  const value = useMemo(
    () => ({ isActive: recording || uploading, setRecording, setUploading }),
    [recording, uploading]
  );
  return <RecordingContext.Provider value={value}>{children}</RecordingContext.Provider>;
};

export const useRecordingState = (): RecordingState => {
  const ctx = useContext(RecordingContext);
  if (!ctx) throw new Error('useRecordingState must be used within a RecordingProvider');
  return ctx;
};
